import { FC, ReactNode } from 'react'
import ActionButton from './ActionButton'
import Popout from './Popout'
import Ellipses from 'src/Icon/Ellipses'
import { Placement } from '@floating-ui/react'

type EllipsesDropdownProps = {
  children: ReactNode
  styles?: string
  padding?: 'sq' | 'sqsm'
  type?: 'primary' | 'secondary'
  placement?: Placement
  id: string
}

const EllipsesDropdown: FC<EllipsesDropdownProps> = ({
  children,
  styles,
  type = 'secondary',
  padding = 'sq',
  placement = 'bottom-end',
  id,
}) => {
  return (
    <Popout
      contents={children}
      popoutClass="rounded-lg bg-white shadow-tooltip border-borderGrey border-[0.5px] px-4 py-2"
      clickEnabled={true}
      hoverEnabled={false}
      ignoreMouse={false}
      placement={placement}
      floatingOffset={{ mainAxis: 4 }}
    >
      {() => (
        <ActionButton
          styles={styles}
          ariaLabel="more options"
          onClick={() => {}}
          type={type}
          padding={padding}
        >
          <Ellipses id={id} />
        </ActionButton>
      )}
    </Popout>
  )
}

export default EllipsesDropdown
